function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
// named imports for React.lazy: https://github.com/facebook/react/issues/14603#issuecomment-726551598
export function lazyImport(factory, name) {
    return Object.create(_define_property({}, name, React.lazy(function() {
        return factory().then(function(module) {
            return {
                default: module[name]
            };
        });
    })));
}
// Usage
// const { Home } = lazyImport(() => import("./Home"), "Home");
export var createLazyInstance = function(TargetClass) {
    var hasProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var instance = null;
    return new Proxy({}, {
        get: function get(target, prop) {
            if (!instance) {
                if (prop === '$$typeof') return null;
                instance = hasProps ? TargetClass() : new TargetClass() // Lazy instantiation of Singleton
                ;
            }
            var value = instance[prop];
            if (typeof value === 'function') {
                // JavaScript does not auto-bind methods from a parent class when calling via a proxy, which is why we need .bind().
                return value.bind(instance);
            }
            return value // Return the corresponding property or method of Singleton
            ;
        }
    });
};
